import { AuthRoute } from "../../components/public/auth/AuthRoute";

export const ForgetPassword = () => <AuthRoute view="forgot" />;
